/**
 *
 * PTV
 *
 * 功能点:PTV演示
 * 场景:沙盘，方案
 * 版本 1.0
 *
 */

import Vue from "@/main";
/**
 * 交通模拟 环境数据
 * @var graphicLayer - ptv的图层
 * @var automobileList - 小车模型库
 *
 */
export let graphicLayer;
let automobileList = [
  {
    url: "/gltf/cart/kache3.gltf",
  },
  {
    url: "/gltf/cart/jiaobanche.glb",
  },
  {
    url: "/gltf/cart/benchi1.gltf",
  },
  {
    url: "/gltf/cart/red_car.gltf",
  },
  {
    url: "/gltf/cart/suv.gltf",
  },
];

/**
 * 交通模拟 数据
 * 1. beginDate - 起始时间 - 存疑（起始时间和结束时间如何设置,是否交由用户配置？会影响到多个CZML一起播放）解决方案为统一设置为：1995-02-08 00:00:00
 * 2. endDate - 结束时间 - 存疑（起始时间和结束时间如何设置,是否交由用户配置？会影响到多个CZML一起播放）解决方案为统一设置为：1995-02-08 23:59:59
 * 3. vehicleSum - 小车总数 - 每条线路的小车总数可以不相同 (经过讨论目前也不交由用户配置)
 * 4. routePointSet - 车道的点集合
 *
 * @var routePointSet - 当前的车道点集合
 * @var vehicleSum - 当前小车总数
 * @var beginDate - 起始时间
 * @var endDate - 结束时间
 *
 */

export let vehicleSum = 1000;
export let beginDate = "1995-02-08T00:00:00.000Z";
export let endDate = "1995-02-08T23:59:59.000Z";

/**
 * 初始化
 * 清空所有数据
 * @returns { any }
 */
export function init() {
  if (graphicLayer) {
    Vue.$GLOBAL.map.removeLayer(graphicLayer);
  }
}

/**
 * 工具类
 * 处理数据 关键函数 处理PTV的数据
 * 把数据处理为CZML格式的数据
 * @param  { Object } data - json 数据
 * @returns { array } - 返回模拟 CZML 数据
 */
export function processingData(data) {
  Vue.$NProgress.configure({
    easing: "ease",
    showSpinner: true,
  });
  Vue.$NProgress.set(0.8).inc(0.2);

  let CZMLData = [];
  let newArr = data.reduce(
    (acc, cur) => {
      let { COORDFRONTX, COORDFRONTY, COORDFRONTZ, SIMSEC } = cur;
      var num = (SIMSEC * 100 - parseInt(100) * 100) / 100;
      console.log(SIMSEC, num);
      let foundIndex = acc.findIndex((item) => item.name === cur.NO);
      let coordinate = mars3d.PointTrans.proj4Trans(
        [Number(COORDFRONTX), Number(COORDFRONTY), Number(COORDFRONTZ)],
        `PROJCS["CGCS2000_3_Degree_GK_CM_114E",GEOGCS["GCS_China_Geodetic_Coordinate_System_2000",DATUM["D_China_2000",SPHEROID["CGCS2000",6378137.0,298.257222101]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["central_meridian",113.75],PARAMETER["false_easting",500000],PARAMETER["false_northing",0],PARAMETER["latitude_of_origin",0],PARAMETER["scale_factor",1],UNIT["metre",1]]`,
        mars3d.CRS.EPSG4326
      );
      if (foundIndex !== -1) {
        acc[foundIndex].position.cartographicDegrees.push(
          num,
          coordinate[0],
          coordinate[1],
          coordinate[2]
        );
      } else {
        CZMLData = [num, coordinate[0], coordinate[1], coordinate[2]];
        acc.push({
          name: cur.NO,
          availability: `${beginDate}/${endDate}`,
          orientation: {
            velocityReference: "#position",
          },
          position: {
            epoch: beginDate,
            cartographicDegrees: CZMLData,
          },
          style: {
            minimumPixelSize: 100,
            distanceDisplayCondition: true,
            distanceDisplayCondition_near: 0,
            distanceDisplayCondition_far: 1300,
            distanceDisplayPoint: {
              // 当视角距离超过一定距离(distanceDisplayCondition_far定义的) 后显示为点对象的样式
              color: "#00ff00",
              pixelSize: 8,
            },
          },
          // },
          model: {
            show: true,
            gltf: randomVehicle(),
            heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
            clampToGround: true,
            scale: 0.6,
            minimumPixelSize: 100,
            maximumScale: 1.5,
          },
          // label: {
          //   fillColor: {
          //     rgba: [0, 255, 255, 255],
          //   },
          //   font: "21pt Lucida Console",
          //   horizontalOrigin: "LEFT",
          //   outlineColor: {
          //     rgba: [0, 0, 0, 255],
          //   },
          //   outlineWidth: 2,
          //   pixelOffset: {
          //     cartesian2: [0, -30],
          //   },
          //   scale: 0.5,
          //   show: true,
          //   style: "FILL_AND_OUTLINE",
          //   text: createLicencePlate() + "--" + ++i,
          //   verticalOrigin: "CENTER",
          // },
        });
      }
      return acc;
    },
    [
      {
        version: "1.0",
        id: "document",
        clock: {
          interval: `${beginDate}/${endDate}`, //开始和结束时间
          currentTime: beginDate,
          multiplier: 1,
        },
        style: {
          distanceDisplayCondition: true,
          distanceDisplayCondition_far: 1000000,
          distanceDisplayCondition_near: 0,
        },
      },
    ]
  );

  let CzmlLayerData = {
    name: "汽车",
    czmlId: "PTV",
    data: newArr,
    autoUpdateClock: false,
    flyTo: true,
  };
  if (graphicLayer) {
    Vue.$GLOBAL.map.removeLayer(graphicLayer);
  }

  graphicLayer = new mars3d.layer.CzmlLayer(CzmlLayerData);
  Vue.$GLOBAL.map.addLayer(graphicLayer);
  Vue.$NProgress.done(true);
  // console.log("ZHANG", CzmlLayerData);
}

/**
 * 工具类
 * 随机生成小车模型
 * 把点集数据处理为CZML格式的数据
 * @returns { string } - 小车的url
 */
function randomVehicle() {
  let index = Math.round(Math.random() * (automobileList.length - 1));
  return automobileList[index].url;
}

export function processingData2() {
  // let CzmlLayerData = {
  //   name: "汽车",
  //   czmlId: "PTV",
  //   url: "/text/ptv1.czml",
  //   autoUpdateClock: false,
  //   flyTo: true,
  // };
  // graphicLayer = new mars3d.layer.CzmlLayer(CzmlLayerData);
  graphicLayer = new mars3d.layer.CzmlLayer({
    name: "船舶编队",
    czmlId: "PTV",
    url: "/text/389707123802181.czml",
    popup: "all",
    autoUpdateClock: false,
    flyTo: true,
  });
  Vue.$GLOBAL.map.addLayer(graphicLayer);
  // Vue.$GLOBAL.map.addLayer(graphicLayer);
}
